const RESET_PASSWORD_EMAIL_SUCCESS_TEXT = "redux_store:authentication.success.reset_password_email";
const RESET_PASSWORD_CONFIRM_SUCCESS_TEXT = "redux_store:authentication.success.reset_password_confirm";
const UPDATE_USER_SETTINGS_SUCCESS_TEXT = "redux_store:authentication.success.update_user_settings";
const UPDATE_USER_PASSWORD_SUCCESS_TEXT = "redux_store:authentication.success.update_user_password";

export const RESET_PASSWORD_EMAIL_SUCCESS = RESET_PASSWORD_EMAIL_SUCCESS_TEXT;
export const RESET_PASSWORD_CONFIRM_SUCCESS = RESET_PASSWORD_CONFIRM_SUCCESS_TEXT;
export const UPDATE_USER_SETTINGS_SUCCESS = UPDATE_USER_SETTINGS_SUCCESS_TEXT;
export const UPDATE_USER_PASSWORD_SUCCESS = UPDATE_USER_PASSWORD_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/authentication.js